import {
  InstrumentoArquivoAnexo,
  InstrumentoAvaliacaoRegistro,
  InstrumentoTurmaContexto
} from '../services/instrumento-avaliacao.service';

export type TipoInstrumentoAvaliacaoId =
  | 'INSTRUMENTO_AVALIACAO'
  | 'RECUPERACAO_PARALELA'
  | 'RECUPERACAO_PERIODO_AVALIATIVO'
  | 'PONTO_EXTRA';

export type InstrumentoFormularioAba = 'informacoes' | 'anexos' | 'dadosAdicionais';

export interface InstrumentoTipoOption {
  id: TipoInstrumentoAvaliacaoId;
  label: string;
}

export interface InstrumentoResumoView {
  id: number;
  descricao: string;
  sigla: string;
  turmaId?: number | null;
  data?: string;
  notaMinima?: number | null;
  notaMaxima?: number | null;
  tipoInstrumento: TipoInstrumentoAvaliacaoId;
  tipoInstrumentoLabel: string;
  modoAvaliacao?: string;
  instrumentoRecuperacaoId?: number | null;
  periodoAvaliativoId?: number | null;
  publico: boolean;
  dataPublicacao?: string | null;
  raw: Record<string, unknown>;
}

export interface InstrumentoTurmaOption extends InstrumentoTurmaContexto {
  descricaoExibicao: string;
}

export interface InstrumentoItemEducacional {
  id: number;
  descricao: string;
  isCampoExperiencia?: boolean;
  etapaMatrizDisciplina?: {
    id: number;
  };
}

export interface InstrumentoCampoAlteracaoCritica {
  campo: keyof InstrumentoFormularioState;
  label: string;
}

export interface InstrumentoAlteracaoDetalhada {
  campo: keyof InstrumentoFormularioState;
  label: string;
}

export interface InstrumentoFormularioState {
  id?: number;
  version?: number | null;
  versao?: number | null;
  turmaId: number | null;
  itemEducacionalId: number | null;
  periodoAvaliativoId: number | null;
  tipoInstrumento: TipoInstrumentoAvaliacaoId | null;
  data: string;
  descricao: string;
  sigla: string;
  conteudo: string;
  criteriosAvaliativos: string;
  instrumentoRecuperacaoId: number | null;
  notaMinima: string;
  notaMaxima: string;
  peso: string;
  modoAvaliacao?: string;
}

export interface InstrumentoArquivoState {
  id?: number | string;
  nome: string;
  tipo?: string;
  tamanho?: number;
  uploading?: boolean;
  raw: InstrumentoArquivoAnexo;
}

export type InstrumentoCampoAdicionalConfig = Record<string, unknown> | Array<Record<string, unknown>> | null;

export interface InstrumentoRecuperacaoVinculadaState {
  aberta: boolean;
  carregando: boolean;
  salvando: boolean;
  adicionarNovo: boolean;
  instrumentoBase: InstrumentoAvaliacaoRegistro | null;
  instrumentoRecuperacao: InstrumentoAvaliacaoRegistro | null;
}

export const INSTRUMENTO_ANEXO_TAMANHO_MAXIMO = 40 * 1024 * 1024;

export const INSTRUMENTO_ANEXO_EXTENSOES_PERMITIDAS = [
  'pdf',
  'doc',
  'docx',
  'txt',
  'html',
  'xls',
  'xlsx',
  'jpg',
  'jpeg',
  'png'
] as const;

export const INSTRUMENTO_CAMPOS_CRITICOS: InstrumentoCampoAlteracaoCritica[] = [
  { campo: 'turmaId', label: 'turma' },
  { campo: 'itemEducacionalId', label: 'componente curricular/atividade' },
  { campo: 'periodoAvaliativoId', label: 'período avaliativo' },
  { campo: 'tipoInstrumento', label: 'tipo de instrumento' },
  { campo: 'data', label: 'data' },
  { campo: 'instrumentoRecuperacaoId', label: 'instrumento recuperado' },
  { campo: 'notaMinima', label: 'menor nota' },
  { campo: 'notaMaxima', label: 'maior nota' },
  { campo: 'peso', label: 'peso' }
];

export const INSTRUMENTO_CAMPOS_FORMULARIO: InstrumentoAlteracaoDetalhada[] = [
  { campo: 'turmaId', label: 'turma' },
  { campo: 'itemEducacionalId', label: 'componente curricular/atividade' },
  { campo: 'periodoAvaliativoId', label: 'período avaliativo' },
  { campo: 'tipoInstrumento', label: 'tipo de instrumento' },
  { campo: 'data', label: 'data' },
  { campo: 'descricao', label: 'descrição' },
  { campo: 'sigla', label: 'sigla' },
  { campo: 'conteudo', label: 'conteúdo' },
  { campo: 'criteriosAvaliativos', label: 'critério avaliativo' },
  { campo: 'instrumentoRecuperacaoId', label: 'instrumento recuperado' },
  { campo: 'notaMinima', label: 'menor nota' },
  { campo: 'notaMaxima', label: 'maior nota' },
  { campo: 'peso', label: 'peso' }
];
